import HousekeepingStatusBoardDispatcher from '../dispatcher/HousekeepingStatusBoardDispatcher'
import HousekeepingStatusBoardConstants from '../constants/HousekeepingStatusBoardConstants'


var HousekeepingStatusBoardActions = {

  init: function (opts) {
    HousekeepingStatusBoardDispatcher.dispatch({
      action: HousekeepingStatusBoardConstants.INIT,
      opts: opts
    });
  },

  gotoDate: function (date) {
    HousekeepingStatusBoardDispatcher.dispatch({
      action: HousekeepingStatusBoardConstants.GOTO_DATE,
      date: date
    });
  },

};

export default HousekeepingStatusBoardActions